export const SECTOR_FIELD_VALUES = [
  { id: 1, label: 'Salud', value: 'Salud' },
  { id: 2, label: 'Educación', value: 'Educación' },
  { id: 3, label: 'Hoteleria y Entretenimiento', value: 'Hoteleria y Entretenimiento' },
  { id: 4, label: 'Corporativo', value: 'Corporativo' },
  { id: 5, label: 'Residencial', value: 'Residencial' },
  { id: 6, label: 'Espacios deportivos y terminales de transporte', value: 'Espacios deportivos y terminales de transporte' }
]